// extracted by mini-css-extract-plugin
export default {"menu-item":"Menu_menu-item__tOcZX","active":"Menu_active__Fa3Xf","icon":"Menu_icon__W08t2","active-icon":"Menu_active-icon__dEWBC","title":"Menu_title__riQxI"};